const styles = "span {\n  padding: 4px;\n  margin: -4px;\n}\n\n:host {\n  display: inline-flex;\n  align-items: center;\n}\n\nbutton {\n  display: inline-block;\n  border: 1px solid #ccc;\n  block-size: 100%;\n  cursor: pointer;\n  margin-inline-start: 4px;\n  padding-block: 1px;\n  padding-inline: 4px;\n}\n\n.overridden {\n  color: var(--go-color-glyph-danger);\n}\n";
export {
  styles as s
};
//# sourceMappingURL=debug.css.js.map
